import { useState, useRef } from 'react';

// Swiper
import SwiperCore, { Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// SwiperCore.use([Navigation]);

const CarouselBox = () => {
    // swiper
    const navigationPrevRef = useRef(null);
    const navigationNextRef = useRef(null);

    return (
        <div className='list-swipe-wrap'>
            <Swiper
                // navigation={{
                //     prevEl: navigationPrevRef.current,
                //     nextEl: navigationNextRef.current,
                // }}
                // onBeforeInit={(swiper) => {
                //     swiper.params.navigation.prevEl = navigationPrevRef.current;
                //     swiper.params.navigation.nextEl = navigationNextRef.current;
                // }}
                spaceBetween={50}
                slidesPerView={5}
                loop={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
                navigation={true}
                // pagination={{ clickable: true }}
                modules={[Autoplay, Pagination, Navigation]}
            >
                <SwiperSlide className='univ-logo kmu' />
                <SwiperSlide className='univ-logo kookmin' />
                <SwiperSlide className='univ-logo daelim' />
                <SwiperSlide className='univ-logo sunmoon' />
                <SwiperSlide className='univ-logo ajou' />
                <SwiperSlide className='univ-logo inha' />
                <SwiperSlide className='univ-logo chungbuk' />
            </Swiper>
        </div>
    );
};

export default CarouselBox;
